import React from 'react';
import styled, { keyframes } from 'styled-components';

const offset = 187;
const duration = '1.4s';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
`;

const colors = keyframes`
  0% {
    stroke: #4285F4;
  }
  25% {
    stroke: #DE3E35;
  }
  50% {
    stroke: #F7C223;
  }
  75% {
    stroke: #1B9A59;
  }
  100% {
    stroke: #4285F4;
  }
`;

const dash = keyframes`
  0% {
    stroke-dashoffset: ${offset};
  }
  50% {
    stroke-dashoffset: ${offset / 4};
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: ${offset};
    transform: rotate(450deg);
  }
`;

const SpinnerContainer = styled.div`
width: 398px;
height: 300px;
display: flex;
flex-direction: row-reverse;
gap: 32px;
justify-content: center;
align-items: center;

`;

const StyledSpinner = styled.svg`
  width: 65px;
  height: 65px;
  animation: ${rotate} ${duration} linear infinite;
`;

const StyledCircle = styled.circle`
  fill: none;
  stroke-width: 5;
  stroke-linecap: round;
  cx: 33;
  cy: 33;
  r: 26;
  stroke-dasharray: ${offset};
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: ${dash} ${duration} ease-in-out infinite, ${colors} ${parseFloat(
    duration
) * 4}s ease-in-out infinite;
`;

const Spinner = () => {
    return (
        <SpinnerContainer>
            <StyledSpinner>
                <StyledCircle className="path" />
            </StyledSpinner>
        </SpinnerContainer>
    );
};

export default Spinner;
